import { CellGlobalActions } from '@components/organisms/Datatable/cells/CellGlobalActions';

const tableSchemaBase = [
	{
		accessor: 'entity',
		title: 'global.producer',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'name',
		title: 'global.name',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},

	{
		accessor: 'technology',
		title: 'global.projectType',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'unlimited',
		title: 'global.financialNeeds',
		type: 'projectAdditionalityUnlimited',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'target_euro',
		title: 'global.target_euro',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'pledged_euro',
		title: 'global.pledged_euro',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'place',
		title: 'global.place',
		sortable: false,
		defaultVisible: false,
	},
	{
		accessor: 'active',
		title: 'global.status',
		sortable: false,
		type: 'activeStatus',
		defaultVisible: false,
	},

	{
		accessor: 'openingDate',
		title: 'global.openingDate',
		sortable: false,
		defaultVisible: false,
	},
	{
		accessor: 'dueDate',
		title: 'global.dueDate',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'organization',
		title: 'global.organization',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'createdAt',
		title: 'global.createdAt',
		sortable: false,
		defaultVisible: false,
	},
	{
		accessor: 'canceledBy',
		title: 'global.canceledBy',
		sortable: false,
		defaultVisible: false,
	},
	{
		accessor: 'canceledAt',
		title: 'global.canceledAt',
		sortable: true,
		defaultVisible: false,
	},
	{
		type: 'additionalitiesActions',
		accessor: 'actions',
		title: <CellGlobalActions />,
		width: 50,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
